import { uniqWith } from 'lodash';

import { formatValueToInputString, parseInputString } from '../ItemsListTextareaEditor/itemsListTextareaEditor';
import { UrlHelpers } from '../UrlHelpers';

export const formatBannedDomainsEditorValue = (items: string[]): string => {
    return formatValueToInputString(items, '\n');
};

export const parseBannedDomainsEditorValue = (inputValue: string): string[] => {
    return uniqWith(
        parseInputString(inputValue, '[\\n,]')
            .map(value => UrlHelpers.stripWww(value))
            .filter(value => value !== ''),
        (value, otherValue) => {
            return value === otherValue;
        }
    );
};
